import script from "./sh-tabs.vue?vue&type=script&lang=js"
export * from "./sh-tabs.vue?vue&type=script&lang=js"

import "./sh-tabs.vue?vue&type=style&index=0&id=d6cd2ef2&lang=less"

const __exports__ = script;

export default __exports__